var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandsL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 200,
    viewBox: "0 0 160 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_929_8217)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M115.522 200L101.272 185.751L155.471 131.552L148.092 124.173L93.8931 178.371L79.6438 164.122L133.842 109.924L126.718 102.799L72.5191 156.997L58.2697 142.748L112.214 88.2952L104.835 81.1705L50.6361 135.369L36.3868 121.12L100.254 56.9975L152.926 109.669L181.679 80.916L121.628 20.8651L142.494 0L229.008 86.514L115.522 200ZM28.2443 114.504L0 86.2595L86.2595 0L167.176 80.916L152.672 95.4198L100 42.7481L28.2443 114.504Z",
    fill: "#002635"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_929_8217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandsL);
export default __webpack_public_path__ + "static/media/handsL.5a1998dcf0f0e97f653204e012576126.svg";
export { ForwardRef as ReactComponent };